// extracted by mini-css-extract-plugin
module.exports =  {"template26__container":"Template26-_7cv__template26__container","model-answer":"Template26-fTTW__model-answer","student-answer":"Template26-KmpV__student-answer"};